import React  from "react";
import { useParams } from 'react-router-dom';
import EmployeeDocuments from "./components/EmployeeDocuments";



const ViewEmployeeDetail = () => {
	const { employeeId } = useParams();
    
	return (
	    <EmployeeDocuments recordId={employeeId} mode="view"/>
    );
};

export default ViewEmployeeDetail;